// @flow
import * as React from 'react';
import _ from 'lodash';

import { Label, Select, FormGroup, Tooltip } from '../../Form';

const getOptions = options => {
	return _.map(options, option => (
		<option key={option.value} value={option.value}>{option.text}</option>
	));
};

type Props = {
	label: string,
	name: string,
	options: Array<Object>,
	input: Object,
	is_disabled: boolean,
	tooltip: {
		title: string,
		description: string,
	},
	onSelectChange?: Function,
};

export const FormSelect = ( { label, name, options, input, tooltip, is_disabled, onSelectChange }: Props ) => (
	<div>
		<Label htmlFor={name} is_disabled={is_disabled}>
			{label}
		</Label>
		<FormGroup>
			{onSelectChange ? <Select
				{...input}
				onChange={value => onSelectChange(value,input.name)}
				name={name}
				is_disabled={is_disabled}
			>
				{getOptions(options)}
			</Select> : <Select
				{...input}
				name={name}
				is_disabled={is_disabled}
			>
				{getOptions(options)}
			</Select>}
			<Tooltip {...tooltip} />
		</FormGroup>
	</div>
);

export default FormSelect;


// WEBPACK FOOTER //
// ./src/components/Form/FormSelect/index.js